import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-68c3796b")

_pushScopeId("data-v-68c3796b")
const _hoisted_1 = { class: "appliance-item-area" }
const _hoisted_2 = { class: "appliance-item-image" }
const _hoisted_3 = {
  key: 1,
  class: "appliance-item-image-no-image",
  src: _imports_0
}
const _hoisted_4 = { class: "appliance-item-right-area" }
const _hoisted_5 = { class: "appliance-item-text-flex" }
const _hoisted_6 = { class: "appliance-item-over-text" }
const _hoisted_7 = { class: "appliance-item-text-flex" }
const _hoisted_8 = { class: "appliance-item-over-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "appliance-item-divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.imageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "appliance-item-image-icon",
              src: _ctx.imageUrl,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onError(...args)))
            }, null, 40, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_3))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.nickName), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.productCode), 1)
        ])
      ]),
      _createVNode("div", {
        class: "appliance-item-check-area",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkAction(...args)))
      }, [
        _createVNode("img", {
          class: "appliance-item-select-button-image",
          src: _ctx.checkedImage()
        }, null, 8, ["src"])
      ])
    ]),
    _hoisted_9
  ], 64 /* STABLE_FRAGMENT */))
})